////////LIBRARY/////////
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { sample, find } from 'lodash'
import { shallowEqual, useSelector } from 'react-redux'
///////COMPONENTS///////
import StringFormatter from '../../../helpers/StringFormatter'
/////////ASSETS/////////
import ErrorAlert from '../../../assets/icones/global/warning-red.svg'
import InfoAlert from '../../../assets/icones/global/info-big-blue.svg'
import PriceFormatter from '../../../helpers/PriceFormatter'

/////////STYLED/////////
const BodyCells = styled.td`
	display: table-cell;
	text-align: center;
	background-color: inherit;
	height: 60px;
	box-sizing: border-box;
	padding: 5px 5px;
	border-top: 1px solid ${(props) => props.theme.colors.table.borderTable};
`
const BodyCellsRightBorder = styled(BodyCells)`
	border-right: 1px solid ${(props) => props.theme.colors.table.borderTable};
`
const ColorSpan = styled.span`
	color: #0885d5;
`
const InputTableRow = styled.input`
	padding: 5px;
	width: 80px;
	text-align: center;
`
const ErrorFormCampaign = styled.div`
	display: flex;
	justify-content: center;
	align-content: center;
	background-color: ${(props) => props.theme.colors.errorlight};
	padding: 10px;
	border-radius: 5px;
`
const InfoFormCampaign = styled.div`
	display: flex;
	justify-content: center;
	align-content: center;
	background-color: ${(props) => props.theme.colors.info};
	padding: 10px;
	border-radius: 5px;
	color: ${(props) => props.theme.colors.primary};
`
const LineInfoImg = styled.img`
	max-height: 20px;
	margin-right: 10px;
`
/////////STYLED/////////

const PriceCampaignCreationSecondLine = (props) => {
	const currency = props.column[0].currency || '$'

	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	const [conversionSales, setConversionSales] = useState({ convert: 0, initial: 0 })

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleWithVAT = (_withVAT, value, taxesRate) => {
		setConversionSales({ convert: PriceFormatter.vatConverter(withVAT, value, taxesRate), initial: value })
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		handleWithVAT(!withVAT, conversionSales.initial, props.row.standardPriceVATRate)
	}, [props.column[0].widthTaxes])

	useEffect(() => {
		handleWithVAT(!withVAT, inputPrice, props.row.standardPriceVATRate)
	}, [])

	const withVAT = props.column[0]?.widthTaxes || false
	const errorsLine = props.column[0].errors.priceValue ? sample(props.column[0].errors.priceValue[props.row.lineNumber]) || false : false
	const errorsCalls = find(props.column[0].callErrors, { lineNumber: props.row.lineNumber }) || false
	const inputPrice = withVAT
		? PriceFormatter.stringToNumberInput(props.row.actualStandardPriceTTC)
		: PriceFormatter.stringToNumberInput(props.row.actualStandardPriceHT)
	const inputDepositPrice = withVAT
		? PriceFormatter.stringToNumberInput(props.row.actualDepositPriceTTC)
		: PriceFormatter.stringToNumberInput(props.row.actualDepositPriceHT)

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<>
			<BodyCellsRightBorder>
				<ColorSpan>Nouvelles valeurs</ColorSpan>
			</BodyCellsRightBorder>
			<BodyCells colSpan="5">
				{errorsLine || errorsCalls ? (
					<ErrorFormCampaign>
						<LineInfoImg src={ErrorAlert} />
						{errorsLine
							? errorsLine.message
							: errorsCalls && (
									<span>
										{StringFormatter.ResponseMessageParser(translations[errorsCalls.traductionKey], errorsCalls.msgParameters)}
									</span>
							  )}
					</ErrorFormCampaign>
				) : (
					<InfoFormCampaign>
						<LineInfoImg src={InfoAlert} />
						<span>{translations['modal__pricesManagement__pricesCampaign_creation_newValues_message']}</span>
					</InfoFormCampaign>
				)}
			</BodyCells>
			<BodyCells>
				<InputTableRow
					type="number"
					defaultValue={inputPrice || 0}
					min={0}
					onBlur={(e) => handleWithVAT(!withVAT, e.target.value, props.row.standardPriceVATRate)}
					name={`priceValue.${props.row.lineNumber}.actualStandardPrice`}
					ref={props.column[0].register({
						min: { value: 0, message: translations['common__message__price_minimum'] },
						max: { value: 9999.999, message: translations['common__message__price_maximum'] },
						required: { value: true, message: translations['common__text__requiredField'] },
						pattern: { value: /^[\d]*[\{.,,}]?\d{0,2}$/, message: translations['common__message__price_decimalMax'] },
					})}
				/>
			</BodyCells>
			<BodyCells>{`${conversionSales.convert}${currency}`}</BodyCells>
			<BodyCells>{`${props.row.standardPriceVATRate}%`}</BodyCells>
			<BodyCells>
				<InputTableRow
					type={'number'}
					defaultValue={inputDepositPrice || 0}
					disabled={!props.row.isWithDepostit}
					min={0}
					name={`priceValue.${props.row.lineNumber}.actualDepositPrice`}
					ref={props.column[0].register({
						min: { value: 0, message: translations['common__message__price_minimum'] },
						max: { value: 9999.999, message: translations['common__message__price_maximum'] },
						required: { value: true, message: translations['common__text__requiredField'] },
						pattern: { value: /^[\d]*[\{.,,}]?\d{0,2}$/, message: translations['common__message__price_decimalMax'] },
					})}
				/>
			</BodyCells>
			<BodyCells>{`${props.row.depositPriceVATRate}%`}</BodyCells>
		</>
	)
}
PriceCampaignCreationSecondLine.propTypes = {}

PriceCampaignCreationSecondLine.defaultPropTypes = {}

export default PriceCampaignCreationSecondLine
